import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { usersApi } from '@/api/index';

export const fetchUsers = createAsyncThunk(
  'users',
  async (params, thunkAPI) => {
    try {
      const response = await usersApi.getAll();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
